import React, { useEffect, useRef, useState} from "react";
import {Button} from "@material-tailwind/react";

const MapComponentSearch = React.memo(({changeData, latitude, longitude}) => {
    const mapRef = useRef(null); // Referencia al contenedor del mapa
    const markerRef = useRef(null); // Referencia al marcador
    const autocompleteRef = useRef(null); // Referencia al Autocomplete de Google
    const [map, setMap] = useState(null); // Instancia del mapa
    const [searchText, setSearchText] = useState(""); // Estado para el input de texto
    const inputRef = useRef(null);

    useEffect(() => {
        if (!window.google) return;
        const google = window.google;

        // Valores predeterminados de latitud y longitud
        const lat = latitude || 29.548060;
        const lng = longitude || -104.417663;
        const zoom =  latitude ? 16 : 13;

        const defaultBounds = {
            north: 29.644539652951327,
            south: 29.323958416041393,
            east: -104.09821543483643,
            west: -104.74217045964511,
        };

        // Opciones del mapa
        const mapOptions = {
            zoom: zoom,
            center: new google.maps.LatLng(lat, lng),
            scrollwheel: false,
            disableDefaultUI: true,
            zoomControl: true,
            mapTypeId: "roadmap",
            restriction: {
                latLngBounds: defaultBounds,
            },
            styles: [
                {
                    featureType: "administrative",
                    elementType: "labels.text.fill",
                    stylers: [{color: "#444444"}],
                },
                {
                    featureType: "landscape",
                    elementType: "all",
                    stylers: [{color: "#f2f2f2"}],
                },
                {
                    featureType: "poi",
                    elementType: "all",
                    stylers: [{visibility: "off"}],
                },
                {
                    featureType: "road",
                    elementType: "all",
                    stylers: [{saturation: -100}, {lightness: 45}],
                },
                {
                    featureType: "road.highway",
                    elementType: "all",
                    stylers: [{visibility: "simplified"}],
                },
                {
                    featureType: "road.arterial",
                    elementType: "labels.icon",
                    stylers: [{visibility: "off"}],
                },
                {
                    featureType: "transit",
                    elementType: "all",
                    stylers: [{visibility: "off"}],
                },
                {
                    featureType: "water",
                    elementType: "all",
                    stylers: [{ color: "#91b1d6" }, { visibility: "on" }],
                },
            ],
        };

        // Inicializar el mapa solo si no se ha hecho antes
        const mapInstance = new google.maps.Map(mapRef.current, mapOptions);
        setMap(mapInstance);

        if(latitude && longitude) {
            markerRef.current = new google.maps.Marker({
                map: mapInstance,
                position: mapOptions.center,
                draggable: false,
                animation: window.google.maps.Animation.DROP,
            });
        }

        autocompleteRef.current = new google.maps.places.Autocomplete(
            inputRef.current,
            {
                bounds: defaultBounds,
                types: ["address"],
                fields: ["address_components", "geometry"],
                strictBounds: true,
                componentRestrictions: { country: "mx" }, // Restringe a México
            }
        );

        autocompleteRef.current.addListener("place_changed", () => {
            const place = autocompleteRef.current.getPlace();
            if (!place.geometry) return;

            const location = place.geometry.location;

            changeData(place);

            // Centrar el mapa en la ubicación seleccionada
            mapInstance.setCenter(location);

            // Mover el marcador a la ubicación seleccionada
            if (markerRef.current) {
                markerRef.current.setPosition(location);
            } else {
                markerRef.current = new window.google.maps.Marker({
                    position: location,
                    map: mapInstance,
                    animation: window.google.maps.Animation.DROP,
                });
            }
        });


    }, []); // Dependencias para actualizar el mapa si cambian

    // Función para manejar la búsqueda de direcciones
    const handleSearch = () => {
        if (!window.google || !map) return;

        const geocoder = new window.google.maps.Geocoder();

        geocoder.geocode({ address: searchText }, (results, status) => {
            if (status === "OK" && results[0]) {
                const location = results[0].geometry.location;

                // Centrar el mapa en la ubicación encontrada
                map.setCenter(location);
                map.setZoom(16);

                // Colocar el marcador en la nueva ubicación
                markerRef.current.setPosition(location);
            } else {
                console.error("Geocode no tuvo éxito por la siguiente razón: " + status);
                alert("No se pudo encontrar la dirección. Intente nuevamente.");
            }
        });
    };

    return (
        <div className="relative w-full h-full">
            {/* Input de búsqueda */}
            <div className="mb-4 flex flex-row gap-4">
                <input
                    ref={inputRef}
                    type="text"
                    className="border-0 px-3 py-3 text-blue-gray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    placeholder="Ingrese una dirección"
                />
                {/*<Button
                    className="w-full text-white rounded-md px-5 py-3 font-semibold max-w-[25%]"
                    onClick={handleSearch}
                >
                    Buscar
                </Button>*/}
            </div>

            {/* Contenedor del mapa */}
            <div
                className="h-96 rounded"
                ref={mapRef}
                style={{height: "400px", width: "100%"}}
            />
        </div>
    );
});

export default MapComponentSearch;
